$(document).on('turbo:load', function () {
  let isMenuPinned = $('.menu').hasClass('open');

  const menuBaseWidth = 60;
  const menuExWidth = 185;

  function showMenuEx() {
    $('.menu-extension').stop(true).animate({
      left: menuBaseWidth
    }, 200);

    $('.menu-toggle-btn-holder').stop(true).animate({
      left: menuBaseWidth + menuExWidth - 245
    }, 200);

    if (isMenuPinned) {
      $('.page-container').stop(true).animate({
        marginLeft: menuExWidth
      }, 200);
    }
  }

  function hideMenuEx() {
    if (!isMenuPinned) {
      $('.menu-extension').stop(true).animate({
        left: -menuExWidth + menuBaseWidth
      }, 200);

      $('.menu-toggle-btn-holder').stop(true).animate({
        left: menuBaseWidth - 245
      }, 200);
    }
  }

  // Toggle button click event
  $('.menu-toggle-btn-holder').click(function () {
    isMenuPinned = !isMenuPinned;

    if (isMenuPinned) {
      $(this).find('i').removeClass('fa-caret-right').addClass('fa-caret-left');
      showMenuEx();
    } else {
      $(this).find('i').removeClass('fa-caret-left').addClass('fa-caret-right');
      hideMenuEx();
      $('.page-container').stop(true).animate({
        marginLeft: 0
      }, 200);
    }

    $.post(`/user_preferences/menu_expanded/${isMenuPinned ? 'open' : 'closed'}`)
      .done(function (data) {
        if (!data['success']) console.log('Something went wrong trying to update user menu expanded preference.');
      });
  });

  // Hover events for both the menu and submenu
  $('.menu, .menu-toggle-btn-holder').hover(function () {
    if (!isMenuPinned) {
      showMenuEx();
    }
  }, function (e) {
    // Check if the mouseout is not due to hovering over a child element
    if (!$(this).find($(e.relatedTarget)).length) {
      if (!isMenuPinned) {
        hideMenuEx();
      }
    }
  });

  const sidePanel = $('#side-panel');
  $('#side-panel-open').click(function () {
    sidePanel.removeClass('d-none').animate({"margin-right": 0});
  });
  $('#side-panel-close').click(function () {
    sidePanel.animate({"margin-right": -310}, function () {
      sidePanel.addClass('d-none');
    });
  });

  $('.userinfo').click(function () {
    $('#user-menu').slideToggle(400);
    $('#user-menu-toggle i').toggleClass("fa-caret-down fa-caret-up");
  });

  // Make alerts close after some time automatically.
  const alerts = $('.alert');
  setTimeout(function () {
    alerts.fadeOut(1_000);
  }, 10_000);

  // Textarea auto height on input.
  const textareaAutoHeights = $('.textarea-auto-height');
  $(document).on('input', '.textarea-auto-height', function () {
    $(this).height(5);
    $(this).height($(this).prop('scrollHeight'));
  });
  textareaAutoHeights.trigger('input');

  // Put this class on any select field, when the field is changed it will auto submit its form.
  $('.select-auto-submit').change(function () {
    $(this).closest('form').submit();
  });

  // Make number fields restrict to numbers on all browsers
  const numberFields = $('input[type="number"]');
  numberFields.on('input', function () {
    $(this).val($(this).val().replace(/-?[^-0-9.]/g, ''));
  });
  numberFields.prop('type', 'text');

  // Make non-number fields restrict to letters
  const nonNumberFields = $('input.non-number-field');
  nonNumberFields.on('input', function () {
    $(this).val($(this).val().replace(/[0-9]/g, ''));
  });

  // Video Modal
  const noticeModal = $('#notice-modal');
  const popupNoticeModal = $('#popup-notice-modal');
  const noticeModalTitle = $('#notice-modal-title');
  const noticeModalCloseBtn = $('#notice-modal-close-btn');
  const noticeModalCloseForeverBtn = $('#notice-modal-close-forever-btn');
  const noticeModalDoNotShow = $('#notice-modal-do-not-show');
  const noticeModalTriggerBtn = $('#notice-modal-trigger-btn');

  function triggerNoticeModal(element) {
    // Get properties from element
    const identifier = element.attr('identifier')
    const title = element.attr('title')
    const dismiss = element.attr('dismiss')
    const dismiss_forever = element.attr('dismiss_forever')
    const video_src = element.attr('video_src')
    const video_title = element.attr('video_title')

    // Update Modal
    if (identifier) noticeModal.attr('identifier', identifier);
    if (title) noticeModalTitle.text(title);
    if (dismiss) noticeModalCloseBtn.text(dismiss);
    if (dismiss_forever) noticeModalCloseForeverBtn.text(dismiss_forever);
    noticeModal.find('iframe').prop({
      src: video_src,
      title: video_title
    });

    // Show Modal
    noticeModal.modal({backdrop: 'static', keyboard: false}).modal('show');
  }

  // noticeModal.on('shown.bs.modal', function() {
  //     // Once modal is shown, remove the popup div.
  //     popupNoticeModal.remove();
  // });
  noticeModal.on('hidden.bs.modal', function () {
    // Once modal is dismissed, stop and reset the video by reloading the iframe.
    const iframe = noticeModal.find('iframe')
    const src = iframe.prop('src');
    iframe.prop('src', '').prop('src', src);
  });
  noticeModalDoNotShow.change(function () {
    const checked = $(this).prop('checked');
    if (checked) {
      noticeModalCloseBtn.addClass('d-none');
      noticeModalCloseForeverBtn.removeClass('d-none');
    } else {
      noticeModalCloseBtn.removeClass('d-none');
      noticeModalCloseForeverBtn.addClass('d-none');
    }
  });
  noticeModalCloseForeverBtn.click(function () {
    $.post('/dismiss_notice_for_current_user', {
      identifier: noticeModal.attr('identifier')
    }).done(function (data) {
      if (!data['success']) alert('Something went wrong, we may show you that again, sorry!');
    });
  });

  // Trigger Modal on page load
  if (popupNoticeModal.length) {
    triggerNoticeModal(popupNoticeModal);
    popupNoticeModal.remove();
  }

  // Trigger Modal on button click
  noticeModalTriggerBtn.click(function () {
    triggerNoticeModal($(this));
  });

  // Set validity text for multiple checkboxes to be different on load
  $('.ff-required input[type=checkbox]').each(function () {
    const parent = $(this).closest('.ff-required');
    if (parent.find('input[type=checkbox]').length >= 2) {
      // Mutiple options, change validity text
      $(this).on('invalid', function () {
        this.setCustomValidity('Please select at least one option to proceed');
      })
    }
  });

  $("#auto_sign").click(function (e) {
    e.preventDefault(); // prevent the form submission

    // auto fill certify_name and certify_signature
    let certifyName = $(this).data("certify-name");
    let certifySignature = $(this).data("certify-signature");
    $("#certify_name").val(certifyName);
    $("#certify_signature").val(certifySignature);
    $('input[name="hs_brand[certify_accurate]"]').prop('checked', true);
  });

  let sort_by = $('#filter-sort-by').val();
  if (sort_by === 'brand_status') {
    $('#brand-status-toggle').prop('checked', true).change();
    $('.brand-status-label').toggle();
  }

  $("input[type=checkbox][name*='ideal_candidate']").on('change', function (evt) {
    updateIdealCandidateDisabled();
  });

  function updateIdealCandidateDisabled() {
    if ($("input[type=checkbox][name*='ideal_candidate']:checked").length >= 6) {
      $("input[type=checkbox][name*='ideal_candidate']:not(:checked)").prop('disabled', true);
    } else {
      $("input[type=checkbox][name*='ideal_candidate']").prop('disabled', false);
    }
  }

  updateIdealCandidateDisabled(); // Do on page load

  // Enforce max 5 selections for characteristics_of_success
  $("input[type=checkbox][name*='characteristics_of_success']").on('change', function () {
    updateCharacteristicsOfSuccessDisabled();
  });

  function updateCharacteristicsOfSuccessDisabled() {
    const selector = "input[type=checkbox][name*='characteristics_of_success']";
    const checkedCount = $(`${selector}:checked`).length;

    if (checkedCount >= 5) {
      $(`${selector}:not(:checked)`).each(function() {
        $(this).prop('disabled', true);
        $(this).closest('.bin-wrapper').addClass('disabled');
        $(this).closest('.bin-wrapper').find('.bin-right').addClass('disabled');
      });
    } else {
      $(selector).each(function() {
        $(this).prop('disabled', false);
        $(this).closest('.bin-wrapper').removeClass('disabled');
        $(this).closest('.bin-wrapper').find('.bin-right').removeClass('disabled');
      });
    }
  }

  updateCharacteristicsOfSuccessDisabled(); // Run on page load

  // Expandable Content

  $('.expandable-content .expand-content-btn').click(function () {
    const parent = $(this).closest('.expandable-content');
    parent.find('.collapsed-content').addClass('d-none');
    parent.find('.expanded-content').removeClass('d-none');
  });

  $('.expandable-content .collapse-content-btn').click(function () {
    const parent = $(this).closest('.expandable-content');
    parent.find('.expanded-content').addClass('d-none');
    parent.find('.collapsed-content').removeClass('d-none');
  });

  // Jira Issue Collector
  $.ajax({
    url: "https://franchisesidekick.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/tod1zk/b/5/b0105d975e9e59f24a3230a22972a71a/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs.js?locale=en-US&collectorId=4a364c39",
    type: "get",
    cache: true,
    dataType: "script"
  });

  let currentUser = $('#current-user-info')
  window.ATL_JQ_PAGE_PROPS = {
    // ==== custom trigger function ====
    "triggerFunction": function (showCollectorDialog) {
      $(".issue-collector").click(function (e) {
        e.preventDefault();
        showCollectorDialog();
      });
    },

    // ==== default field values ====
    fieldValues: {
      fullname: currentUser.attr('full_name'),
      email: currentUser.attr('email'),
      // Service Request Type: General Support
      'customfield_10098': '10119'
    }
  };

  $('select.select2').select2({
    theme: "bootstrap-5"
  });

  // Bind height to another element
  $('.match-height-js').each(function() {
    const target = $(this).attr('target_element');
    if (!target) return;
    if ($(target).length) bindHeight($(this), $(target));
  });

  adjustFullHeightElements();
}); // End turbo:load

// Bind height to an element based on the height of another element.
const bindHeight = (el, target) => {
  if (!target.length) return;
  const update = () => el.height(target.outerHeight());
  update();
  new ResizeObserver(() => requestAnimationFrame(update)).observe(target[0]);
};

$(document).on('turbo:before-cache', function () {
  $('.select2').each(function () {
    if ($(this).data('select2')) {
      $(this).select2('destroy');
    }
  });
});
// $(document).on('click', 'example', ...) functions need to be in a document ready function rather than a turbo load function
// because otherwise they can get bound multiple times and execute multiple times with one click.
$(document).ready(function () {
  $(document).on('click', '.expand-table', function () {
    let expandable_items = $(this).closest('tbody').find("[team='" + $(this).attr('team') + "'].expandable");
    expand_or_collapse(expandable_items);
  });

  $(document).on('click', '.expand-card', function () {
    let expandable_items = $(this).closest('.card').find(".expandable");
    expand_or_collapse(expandable_items);
  });

  $(document).on('click', '.expand-all', function () {
    let expandable_items = $(".expandable");
    expand_or_collapse(expandable_items);
  });

  $(document).on('click', '.toggle-fillable-fields', function () {
    $(this).closest('table').find("tbody [date_column='" + $(this).closest('th').attr('date_column') + "']").toggle();
    let expandable_items = $(this).closest('.card').find(".expandable");
    expand_or_collapse(expandable_items, true);
  });

  // On change of a select field with the class auto-submit-select-js, or a select field in a form
  // with the class auto-submit-select-js, submit the form in a way that turbo will handle.
  $(document).on('change', 'form.auto-submit-select-js select, select.auto-submit-select-js', function () {
    $(this).closest('form')[0].requestSubmit();
  });

  // Toggle d-none class on target elements when source element is clicked.
  $(document).on('click', '.toggle-d-none-js', function () {
    const target = $($(this).attr('target'));
    if (target.first().hasClass('d-none')) target.removeClass('d-none');
    else target.addClass('d-none');
  });

  function expand_or_collapse(expandable_items, force_expand = null) {
    let expand = false
    if (force_expand !== null) expand = force_expand
    else {
      expandable_items.each(function () {
        if ($(this).css('display') === 'none') {
          expand = true
          return false;
        }
      });
    }

    if (expand) {
      expandable_items.each(function () {
        if ($(this).css('display') === 'none') {
          $(this).css('display', 'table-row')
        }
      });
    } else {
      expandable_items.each(function () {
        $(this).css('display', 'none')
      });
    }
  }

  $(document).on('input', '.conversion-td input', function () {
    const inputs = $(this).closest('td').find('input');
    let value1 = parseInt(inputs[0].value);
    let value2 = parseInt(inputs[1].value);
    if (isNaN(value1) || isNaN(value2)) {
      $(this).closest('td').find('.conversion').html('-');
    } else {
      let calculated = null
      if (value2 === 0) calculated = 0;
      else if (value1 > 0) calculated = (value2 / value1) * 100;
      $(this).closest('td').find('.conversion').html(calculated != null ? calculated.toFixed(1) + '%' : '<span style="font-size: 1.4em; line-height: 1em;">∞</span>');
    }
  });

  $(window).resize(function () {
    adjustFullHeightElements();
  });

  // Tabs can be just visual, or can also have attributes that hide and show content.
  // Example Usage without content:
  // .sk-tabs-js
  //   .sk-tab-js.active Tab 1
  //   .sk-tab-js Tab 2
  //
  // Example Usage with content:
  // (must be inside tabs-scope to limit scope. Without this, all tabs on the page will be affected)
  // .sk-tabs-js-scope
  //   .sk-tabs-js
  //     .sk-tab-js.active{content: 'content-1'} Tab 1
  //     .sk-tab-js{content: 'content-2'} Tab 2
  //   .sk-tab-js-content{content: 'content-1'} Content 1
  //   .sk-tab-js-content.d-none{content: 'content-2'} Content 2
  $(document).on('click', '.sk-tabs-js .sk-tab-js', function () {
    // Visual Tabs
    const tabs = $(this).closest('.sk-tabs-js');
    const allTabs = tabs.find('.sk-tab-js');
    allTabs.removeClass('active');
    $(this).addClass('active');

    // Optional Content
    const contentIdentifier = $(this).attr('content');
    if (!contentIdentifier) return;

    // Find out the scope we should stay within for tabs.
    // Will limit to the closest tabs-scope, then the closest component, then the whole document if needed.
    let tabsScope = tabs.closest('.sk-tabs-js-scope');
    if (!tabsScope.length) tabsScope = tabs.closest('.component');
    if (!tabsScope.length) tabsScope = $(document);

    // Hide all content, then show the content that matches the tab.
    const allContent = tabsScope.find('.sk-tab-js-content');
    allContent.addClass('d-none');
    allContent.filter(`[content='${contentIdentifier}']`).removeClass('d-none');
  });

  // Copy Something to Clipboard
  // Example Usage:
  // .btn.btn-primary.clipboard-copy{copy: 'Text to Copy', notice: 'Optional Notice to Display'} Click to Copy
  $(document).on('click', '.clipboard-copy', function () {
    const copyText = $(this).attr('copy');
    const notice = $(this).attr('notice');

    let message = '';
    if (notice) message = notice + "\n\n"

    // Copy the text inside the text field
    navigator.clipboard.writeText(copyText).then(() => {
      alert(message + "Copied to Clipboard: " + copyText);
    }).catch(() => {
      alert(message + "Failed to Copy to Clipboard. Copy Manually: " + copyText);
    });
  });

  // Sorting table columns by clicking on the header
  // Can sort by numbers and strings (case-insensitive)
  // Sorts in ascending order by default, and toggles between ascending and descending on each click
  // Useage:
  // Add the class 'column-sortable-js' to the header text element of the column you want to make sortable
  // (Optional) Add the class 'column-sortable-data-js' to the data element of the column you want to sort by
  // (Optional) Add the class 'column-sortable-exclude-tr-js' to the tr element of the row you want to exclude from sorting
  // (Optional) Add the attribute 'sort_value' to the data element of the column you want to sort by
  // Example:
  // <table>
  //   <thead>
  //     <tr>
  //       <th><span class="column-sortable-js">Name</span></th>
  //       <th><span class="column-sortable-js">Age</span></th>
  //     </tr>
  //   </thead>
  //   <tbody>
  //     <tr>
  //       <td>>John Doe</td>
  //       <td><span class="column-sortable-data-js">25</span></td>
  //     </tr>
  //     <tr>
  //       <td>Jane Doe</td>
  //       <td><span class="column-sortable-data-js">30</span></td>
  //     </tr>
  //     <tr>
  //       <td>Jane Doe</td>
  //       <td><span class="column-sortable-data-js" sort_value="35">35 years old</span></td>
  //     </tr>
  //   </tbody>
  // </table>
  let isAscending = false;
  let previousColumnName = null;

  $(document).on('click', '.column-sortable-js', function () {
    const $header = $(this);
    const $table = $header.closest('table');
    const columnIndex = $header.closest('th').index();  // Get the column index

    // Clear arrows from all other headers
    $('.column-sortable-js').each(function () {
      $(this).text($(this).text().replace(/[▲▼]/g, '').trim());
    });

    // Check if the same column was clicked; reset to ascending if not
    const currentColumnName = $header.text().replace(/[▲▼]/g, '').trim();
    if (previousColumnName !== currentColumnName) {
      isAscending = false;  // Reset to ascending if a new column is clicked
      previousColumnName = currentColumnName;
    }

    // Toggle the sorting order and add the appropriate arrow
    if (isAscending) {
      $header.text(`${currentColumnName} ▲`);
    } else {
      $header.text(`${currentColumnName} ▼`);
    }

    // Get all rows of the table body that are not excluded
    const rows = $table.find('tbody tr').not('.column-sortable-exclude-tr-js').toArray();

    // Get the excluded rows
    const excludedRows = $table.find('tbody tr.column-sortable-exclude-tr-js').toArray();

    // Sort rows based on the content of the clicked column
    rows.sort((a, b) => {

      // Helper function that returns the sort value from a given row and column index.
      const getSortValue = (row, index) => {
        const $td = $(row).find('td').eq(index);

        let value;

        if ($td.hasClass('column-sortable-data-js')) {
          value = $td.attr('sort_value');
          if (value) return value;

          return $td.text().trim()
        } else {
          value = $td.find('.column-sortable-data-js').attr('sort_value')
          if (value) return value;

          value = $td.find('.column-sortable-data-js').text().trim()
          if (value) return value;

          return $td.text().trim()
        }
      };

      const tdA = getSortValue(a, columnIndex);
      const tdB = getSortValue(b, columnIndex);

      const isEmptyA = !tdA || tdA === '';
      const isEmptyB = !tdB || tdB === '';

      // Always push the empty values to the end rows
      if (isEmptyA && !isEmptyB) return 1;
      if (!isEmptyA && isEmptyB) return -1;
      if (isEmptyA && isEmptyB) return 0;

      // Try to parse numbers;
      const numA = parseFloat(tdA);
      const numB = parseFloat(tdB);

      // Try to parse dates
      const dateA = Date.parse(tdA);
      const dateB = Date.parse(tdB);

      // First do number because 7 is a date
      if (!isNaN(numA) && !isNaN(numB)) {
        return isAscending ? numA - numB : numB - numA;
      } else if (!isNaN(dateA) && !isNaN(dateB)) {
        return isAscending ? dateA - dateB : dateB - dateA;
      } else {
        // localeCompare is case sensitive
        const stringA = tdA.toLowerCase();
        const stringB = tdB.toLowerCase();
        return isAscending ? stringA.localeCompare(stringB) : stringB.localeCompare(stringA);
      }
    });

    // Reinsert sorted rows into the table
    $.each(rows, (index, row) => {
      $table.find('tbody').append(row);
    });

    // Reinsert excluded rows into the table
    $.each(excludedRows, (index, row) => {
      $table.find('tbody').append(row);
    });

    // Toggle the sort order for the next click
    isAscending = !isAscending;
  });


  $(document).on('click', '.input-text-box-js', function () {
    const label = $(this).find('label')

    if (!label.hasClass('has-value')) {
      label.addClass('has-value');
    }
  });

  // Input text box should only allow numbers or , if attr numbers_only is true
  $(document).on('input', '.input-text-box-js input', function () {
    if ($(this).attr('numbers_only') === "true") {
      $(this).val($(this).val().replace(/[^0-9,]/g, ''));
    }
  });

  // Input text box
  // When .input-text-box-js loses focus, check if it has a value and add a class to the parent
  $(document).on('focusout', '.input-text-box-js', function () {
    // Find element with id of input
    const input = $(this).find('input');
    // Check if input element has a value
    const hasValue = input.val().length > 0;
    // Add class has-value to element with id of label
    const label = $(this).find('label')

    // Check if input is type number or text
    if (input.attr('numbers_only') === "true") {
      // Remove ',' in thousands and trim
      input.val(input.val().toString().replace(/,/g, '').trim());

      // Add ',' in thousands
      let formatted_string = input.val().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

      input.val(formatted_string);
    }

    label.toggleClass('has-value', hasValue);
  });

});

// Functions that can be called by both turbo loaded code and document ready code

function adjustFullHeightElements() {
  $('.full-height-js').each(function () {
    $(this).css('height', $(window).height() - $(this).offset().top - 20);
  });
}


//------------------------ Keyword Filtering ------------------------//

/*
Reusable real-time keyword filtering that can be used on any page, and even multiple times on any page.

Example Usage:
.keyword-filterable
    = text_field_tag :keyword_filter, nil, placeholder: 'Filter by Name', class: 'keyword-filter form-control'
    %h1.keyword-item{keyword: 'Item One'} Item One
    %h1.keyword-item{keyword: 'Item Two'} Item Two
    %h1.keyword-item{keyword: 'Item Three'} Item Three

Real example on brand_groups/index.html.haml
*/
$(document).ready(function () {
  $(document).on('input', '.keyword-filterable .keyword-filter', function () {
    const keywordFilter = $(this).val();
    // Look only under the filterable parent element in case there are multiple filters on the page.
    const filterable = $(this).closest('.keyword-filterable');
    filterable.find('.keyword-item').each(function () {
      // Add d-none class if the keyword filter exists and the keyword-item doesn't match the filter text.
      // Remove d-none class if keyword filter is empty or the keyword-item matches the filter text.
      const hide = keywordFilter && !$(this).attr('keyword').match(new RegExp(keywordFilter, 'i'));
      if (hide) $(this).addClass('d-none');
      else $(this).removeClass('d-none');
    });
  });
})

$(document).on('click', '.franchise-review-sort', function () {
  const sortBy  = $(this).attr('sort_by');
  const sortDir = $(this).attr('sort_dir');

  const params = new URLSearchParams(window.location.search);
  params.set('sort', sortBy);
  params.set('sort_dir', sortDir);

  window.location.search = params.toString();
});
